import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



const StudentAdmissionForm = () => {
  const [students, setStudents] = useState([]);
  const [grades, setGrades] = useState([]);
  const [formData, setFormData] = useState({
    student: "",
    studentId_no: "",
    full_name: "",
    grade: "",
    student_class: "",
    major_subject: "",
    date_of_birth: "",
    address: "",
    mother_name: "",
    father_name: "",
    health_status: "",
    parent_contact: "",
    enrollment_date: "",
    semester: "",
    profile_image: null,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch student users and grades from the backend
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [studentsResponse, gradesResponse] = await Promise.all([
          axios.get("https://www.janalwilliamsedufoundation.online/users/students/"), // Fetch student users
          axios.get("https://www.janalwilliamsedufoundation.online/grade-classes/"), // Fetch grades
        ]);
        setStudents(studentsResponse.data);
        setGrades(gradesResponse.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to load data");
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, profile_image: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      formDataToSend.append(key, formData[key]);
    });

    try {
      await axios.post("https://www.janalwilliamsedufoundation.online/admissions/", formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`, // Ensure token is added
        },
      });
      toast.success("Student admission submitted successfully!");
      setFormData({
        student: "",
        studentId_no: "",
        full_name: "",
        grade: "",
        student_class: "",
        major_subject: "",
        date_of_birth: "",
        address: "",
        mother_name: "",
        father_name: "",
        health_status: "",
        parent_contact: "",
        enrollment_date: "",
        semester: "",
        profile_image: null,
      });
      setLoading(false);
    } catch (err) {
      setError("Failed to submit the form. Please try again.");
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      <h2>Student Admission Form</h2>
      <ToastContainer />
      {loading && <p>Loading...</p>}
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleSubmit}>
        <select
          name="student"
          value={formData.student}
          onChange={handleChange}
          required
        >
          <option value="">Select Student</option>
          {students.map((student) => (
            <option key={student.id} value={student.id}>
              {student.username}
            </option>
          ))}
        </select>
        <input
          type="text"
          name="studentId_no"
          placeholder="Student ID"
          value={formData.studentId_no}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="full_name"
          placeholder="Full Name"
          value={formData.full_name}
          onChange={handleChange}
          required
        />
        <select
          name="grade"
          value={formData.grade}
          onChange={handleChange}
          required
        >
          <option value="">Select Grade</option>
          {grades.map((grade) => (
            <option key={grade.id} value={grade.id}>
              {grade.name}
            </option>
          ))}
        </select>
        <input
          type="text"
          name="student_class"
          placeholder="Class"
          value={formData.student_class}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="major_subject"
          placeholder="Major Subject"
          value={formData.major_subject}
          onChange={handleChange}
          required
        />
        <input
          type="date"
          name="date_of_birth"
          placeholder="Date of Birth"
          value={formData.date_of_birth}
          onChange={handleChange}
          required
        />
        <textarea
          name="address"
          placeholder="Address"
          value={formData.address}
          onChange={handleChange}
          required
        ></textarea>
        <input
          type="text"
          name="mother_name"
          placeholder="Mother's Name"
          value={formData.mother_name}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="father_name"
          placeholder="Father's Name"
          value={formData.father_name}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="health_status"
          placeholder="Health Status"
          value={formData.health_status}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="parent_contact"
          placeholder="Parent Contact"
          value={formData.parent_contact}
          onChange={handleChange}
          required
        />
        <input
          type="date"
          name="enrollment_date"
          placeholder="Enrollment Date"
          value={formData.enrollment_date}
          onChange={handleChange}
          required
        />
        <select
          name="semester"
          value={formData.semester}
          onChange={handleChange}
          required
        >
          <option value="">Select Semester</option>
          <option value="First">First</option>
          <option value="Second">Second</option>
        </select>
        <input type="file" name="profile_image" onChange={handleFileChange} />
        <button type="submit" disabled={loading}>
          Submit
        </button>
      </form>
    </div>
  );
};

export default StudentAdmissionForm;

